<template>
	<div class="recharge-list">
		<div class="header">
			<span class="back" @click="back" v-if="client_type!='app'">返回</span>
        		<p class="title" v-if="type==0">手机充值账单</p>
        		<p class="title" v-else>优酷会员购买记录</p>

		</div>
		<div class="list">
			<ul>
				<li v-for="(item,index) in historyList" @click="goRecharge(item.mobile)">
					<div class="picture">
						<img  v-if="type==0" src="../assets/img/phone-icon@2x.png"/>
						<img v-else src="../assets/img/youkuBg.png"/>
					</div>
					<div class="content">
						<p class="number">
							<span v-if="type==0">{{item.mobile}}</span>
							<span v-else>{{item.recharge_account}}</span>
							</p>
						<p class="time">{{item.created | timestampToTime}}</p>
					</div>
					<div class="money" :class="{'moneyBg':type==0}" v-if="type==0">{{item.amount}}</div>
					<div class="money" v-else>{{item.package_name}}</div>

				</li>
			</ul>
			<div class="noList" v-if="historyList.length==0">暂无记录</div>
		</div>
	</div>
</template>

<script>
	import {rechargeParam} from '../assets/js/common.js'
	
    export default{
		data(){
			return{
				historyList:{},
				client_type:"",
				type:0
			}
		},
		created(){
			this.type=this.$route.query.type;
			let UA = navigator.userAgent.toLowerCase();
			if(/(uni-app)/.test(UA) || /(ylkids_android)/.test(UA) || /(ios1.1.0)/.test(UA)) {
							this.client_type="app";
			}
//			获取充值记录列表
			let url;
			if(this.type==0){
				url="/test/v1/recharge/history?";
			}else{
				url="/test/v1/yk-vip/pay-history?";
			}
			this.$http.get(url+rechargeParam({
				params:{
//					mobile:localStorage.getItem("telphone"),
					page_size:99
				}
			},false,false)).then((response) => {
				if(response.data.error == 0){
					this.historyList = response.data.data.list;

				}else if(response.data.error == "30005"){
					
				}else{
					alert(response.data.msg);
					
				}
			})
		},
		methods:{
			back(){
				this.$router.push({path:'home'})
			},
			goRecharge(mobile){
				if(this.type==1){
					return false;
				}
//				localStorage.setItem("rechargeNum",mobile);
				this.$router.push({path:'home',query:{mobile: mobile}});
			}
		},
		filters:{
			timestampToTime:function(timestamp) {
		        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
		        var Y = date.getFullYear() + '-';
		        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
		        var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
		        var h = (date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours()) + ':';
		        var m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ':';
		        var s = (date.getSeconds() < 10 ? '0'+(date.getSeconds()) : date.getSeconds());
		        return Y+M+D+h+m+s;
		    }
		}
    }
</script>

<style scoped="scoped">
	.recharge-list{
		width: 100%;
		height: 100%;
		background:rgba(245,245,245,1);
	}
	.recharge-list .header{
	    /*padding-top: 0.48rem;*/
		position: relative;
		width:100%;
		height:0.8rem;
		background:rgba(255,255,255,1);
	}
	.recharge-list .header .title{
		/*margin-top: 0.48rem;*/
		width:100%;
		height:0.8rem;
		font-size:0.34rem;
		font-family:SourceHanSansCN;
		font-weight:400;
		color:rgba(102,102,102,1);
		line-height:0.8rem;
		text-align: center;
	}
	.recharge-list .back{
		position: absolute;
		left: 0.3rem;
		padding-left: 0.28rem;
		display: inline-block;
		width:1.2rem;
		height:0.8rem;
		font-size:0.3rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(74,144,226,1);
		line-height:0.8rem;
		background: url(../assets/img/back@2x.png) no-repeat left center;
		background-size: 0.23rem;
	}
	.recharge-list .list{
		padding-top: 0.4rem;
		height: 85%;
		overflow-y: scroll;
	}
	.recharge-list .list ul{
		
	}
	.recharge-list .list li{
		display: flex;
		margin: 0 auto;
		margin-bottom: 0.1rem;
		width: 6.79rem;
		height: 1.66rem;
		background: url(../assets/img/records-bg@2x.png) no-repeat;
		background-size: 100%;
	}
	.recharge-list .list li .picture{
		flex: 1;
		/*width: 1.4rem;*/
		height: 1.66rem;
	}
	.recharge-list .list li .picture img{
		margin: 0.31rem auto;
		display: block;
		width: 1.04rem;
		height: 1.04rem;
	}
	.recharge-list .list li .content{
		flex: 2;
		margin-top: 0.45rem;
	}
	.recharge-list .list li .content .number{
		width:100%;
		height:0.5rem;
		font-size:0.36rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(68,68,68,1);
		line-height:0.5rem;
	}
	.recharge-list .list li .content .time{
		width:100%;
		height:0.28rem;
		font-size:0.2rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(68,68,68,1);
		line-height:0.28rem;
	}
	.recharge-list .list li .money{
		flex: 1.8;
		height:1.66rem;
		font-size:0.3rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(68,68,68,1);
		line-height:1.66rem;
	}
	.moneyBg{
		background: url(../assets/img/recharge@2x.png) no-repeat right center !important;
		background-size: 0.83rem 0.38rem !important;

	}
	.noList{
		font-family:SourceHanSansCN;
		font-weight:400;
		color:rgba(102,102,102,1);
		font-size:0.34rem;
		text-align:center;
	
	}
</style>


// WEBPACK FOOTER //
// src/components/recharge-list.vue